import React, { useState } from 'react';
import {
	makeStyles,
	Button,
	MenuItem,
	LinearProgress,
	Box,
	TextField,
	InputAdornment,
	Grid,
	Tabs,
	Tab,
	Divider,
	withStyles,
	FormControlLabel,
	Checkbox,
} from '@material-ui/core';
import DayPickerInput from 'react-day-picker/DayPickerInput';
// import 'react-datepicker/dist/react-datepicker.css';
// import 'react-day-picker/lib/style.css';

import '../../../node_modules/react-day-picker/lib/style.css';
import { green } from '@material-ui/core/colors';

// import { TextField } from 'formik-material-ui';
// import TextField from '@material-ui/core/TextField
import { Field, Form, Formik } from 'formik';
import PhoneIcon from '@material-ui/icons/Phone';
import TitleText from '../../components/reusableComponents/TitleText';
import { useMediaQuery, useTheme } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import BodyText from './BodyText';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import DatePicker from '@mui/lab/DatePicker';
// import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 10,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 25,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: '#39c9bb',
		color: 'white',
		borderRadius: 25,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: '#39c9bb',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 25,
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const country = ['Mr', 'Mrs'];
const visa = [
	'Tourist',
	'Employment',
	'Seamen',
	'Residence',
	'Student',
	'Dependent',
	'Migrant',
];
const TravellerForm = () => {
	const classes = useStyles();
	// const theme = useTheme();
	const [value3, setValue3] = React.useState(new Date());

	// const handleChange = (event, newValue) => {
	// 	setValue(newValue);
	// };
	const [value, setValue2] = React.useState(null);
	const [startDate, setStartDate] = useState(new Date());

	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
	};
	const [currentStep, SetCurrentStep] = useState('Step 1');

	// const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const handleSubmit = (data) => {
		console.log(data);
	};

	return (
		<>
			<Formik
				initialValues={{}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting }) => (
					<>
						<Form>
							<>
								{[0, 1].map((i, index) => {
									return (
										<>
											<Grid container spacing={2} alignItems='center'>
												<Grid
													item
													xs={3}
													style={{ display: 'flex', alignItems: 'center' }}>
													<Box display='flex'>
														<TitleText two>{index + 1}</TitleText>
														<TitleText two textStyle={{ marginLeft: 5 }}>
															Adult
														</TitleText>
													</Box>
													<Field
														component={TextField}
														select
														name='user'
														type='text'
														label='Title'
														variant='outlined'
														style={{ marginTop: 19, marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}>
														{country.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														label='Enter First Name'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Last Name'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3} style={{ marginBottom: 12 }}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															views={['year', 'month', 'day']}
															value={value3}
															onChange={(newValue) => {
																setValue3(newValue);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant='outlined'
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={2}></Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														label='Enter Passport Number'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Expiry Date'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Issuing Date'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={2}></Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														select
														name='user'
														type='text'
														label='Select Visa Type'
														variant='outlined'
														style={{ marginTop: 19 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}>
														{visa.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Issuing Place'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
											</Grid>
										</>
									);
								})}
								{[0].map((i, index) => {
									return (
										<>
											<Grid container spacing={2} alignItems='center'>
												<Grid
													item
													xs={3}
													style={{ display: 'flex', alignItems: 'center' }}>
													<Box display='flex'>
														<TitleText two>{index + 1}</TitleText>
														<TitleText two textStyle={{ marginLeft: 5 }}>
															Child
														</TitleText>
													</Box>
													<Field
														component={TextField}
														select
														name='user'
														type='text'
														label='Title'
														variant='outlined'
														style={{ marginTop: 19, marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}>
														{country.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														label='Enter First Name'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Last Name'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3} style={{ marginBottom: 12 }}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															views={['year', 'month', 'day']}
															value={value3}
															onChange={(newValue) => {
																setValue3(newValue);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant='outlined'
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={2}></Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														label='Enter Passport Number'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Expiry Date'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Issuing Date'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={2}></Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														select
														name='user'
														type='text'
														label='Select Visa Type'
														variant='outlined'
														style={{ marginTop: 19 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}>
														{visa.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Issuing Place'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
											</Grid>
										</>
									);
								})}
								{[0].map((i, index) => {
									return (
										<>
											<Grid container spacing={2} alignItems='center'>
												<Grid
													item
													xs={3}
													style={{ display: 'flex', alignItems: 'center' }}>
													<Box display='flex'>
														<TitleText two>{index + 1}</TitleText>
														<TitleText two textStyle={{ marginLeft: 5 }}>
															Infant
														</TitleText>
													</Box>
													<Field
														component={TextField}
														select
														name='user'
														type='text'
														label='Title'
														variant='outlined'
														style={{ marginTop: 19, marginLeft: 10 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}>
														{country.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														label='Enter First Name'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Last Name'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3} style={{ marginBottom: 12 }}>
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															// disableFuture
															label='Date'
															openTo='year'
															views={['year', 'month', 'day']}
															value={value3}
															onChange={(newValue) => {
																setValue3(newValue);
															}}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant='outlined'
																	className={classes.date}
																/>
															)}
														/>
													</LocalizationProvider>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={2}></Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														name='first_name'
														type='text'
														variant='outlined'
														label='Enter Passport Number'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Expiry Date'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
												<Grid item xs={3}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Issuing Date'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
											</Grid>
											<Grid container spacing={2} alignItems='center'>
												<Grid item xs={2}></Grid>
												<Grid item xs={4}>
													<Field
														component={TextField}
														select
														name='user'
														type='text'
														label='Select Visa Type'
														variant='outlined'
														style={{ marginTop: 19 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}>
														{visa.map((item, index) => (
															<MenuItem key={index} value={item}>
																{item}
															</MenuItem>
														))}
													</Field>
												</Grid>
												<Grid item xs={6}>
													<Field
														component={TextField}
														name='first_name'
														type='select'
														variant='outlined'
														label='Enter Issuing Place'
														style={{ marginTop: 20 }}
														className={classes.selectField}
														InputProps={{
															className: classes.InputPropsStyle,
														}}
														inputProps={{
															style: { padding: 18 },
														}}
													/>
												</Grid>
											</Grid>
										</>
									);
								})}
							</>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default TravellerForm;
